import React from 'react';

import '../../../public/scss/prvdrSearch.scss';
import HeroBanner from './HeroBanner';
import SearchBar from './SearchBar';

const Index = () => {
    return (
        <>
            <HeroBanner />
            <div>
                <SearchBar />
            </div>
        </>
    );
};

export default Index;
